import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

export const SkeletonLoaderStyled = styled(Skeleton)(
  ({ theme: { spacing } }) => ({
    opacity: '30%',
    marginBottom: spacing(1),
  })
);
